/**
 * Strips Rhino-internal and HeroUI v2 props that should not reach DOM elements.
 *
 * These props are passed through the Rhino override/hook system but are not
 * valid HTML attributes or HeroUI v3 component props. Spreading them to a
 * React component would cause "unknown prop" warnings.
 */
const RHINO_INTERNAL_PROPS = new Set([
  'attribute',
  'attributeModel',
  'plainPath',
  'operator',
  'onClear',
  'labelPlacement',
  'isClearable'
]);

export function stripRhinoProps<T extends Record<string, unknown>>(
  props: T
): Omit<T, keyof typeof RHINO_INTERNAL_PROPS> {
  const clean = {} as Record<string, unknown>;
  for (const key in props) {
    if (!RHINO_INTERNAL_PROPS.has(key)) {
      clean[key] = props[key];
    }
  }
  return clean as Omit<T, keyof typeof RHINO_INTERNAL_PROPS>;
}
